import React, { useState, useEffect } from 'react'
import { useMsal } from '@azure/msal-react';
import { getAzureUser } from '../API/User/User';

const NoAccess = () => {

    const context = useMsal()

    const [user, setUser] = useState({});

    useEffect(() => {
        const getUserData = async () => {
            const user = await getAzureUser(context);
            setUser(user);
        };
        if(context.inProgress === "none"){
            getUserData();
        }
    }, [context]);

    return (
        <div className="d-center h-75 d-flex align-items-center justify-content-center">
            <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6">
                    <img width={500} src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/AccessDenied.jpg`} alt="responsive webite" className="img-fluid" />
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6">
                    <div className='h-25'></div>
                    <h2 className="mb-4">Sorry, {user && user.name}
                    </h2>
                    <p className="mb-4">
                        You don't have permission to access App Maker. Please contact your administrator
                    </p>
                    <a target="_blank" href={process.env.REACT_APP_RUNTIME_URL} rel="noreferrer">
                        You can go to your App Workspace from here
                    </a>
                </div>
            </div>
        </div >
    )
}

export default NoAccess
